<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card :title="pageTitle">
        <p class="mb-4">This route is ready.</p>
        <p class="mb-2"><strong>Current Route:</strong> {{ $route.path }}</p>
        <p class="mb-2"><strong>Page Title:</strong> {{ pageTitle }}</p>
        <p class="mb-2">
          Replace this placeholder component later with the final screen without changing router or nav menu.
        </p>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    pageTitle() {
      return (this.$route.meta && this.$route.meta.pageTitle) || "Module Placeholder";
    }
  }
}
</script>
